import {
  AllCommunityModule, ModuleRegistry,
} from 'ag-grid-community';
import React, { FC, Fragment } from 'react';

import { ErrorBoundary } from '../components';
import { useRoutesWithBreadcrumbs } from '../context';
import {
  AccessDenied,
  ProtectedRoute, SetPassword, SignIn,
} from '../route';
import { AdsEntrypoint } from './Ads';
import { AdsGeneratorEntrypoint } from './AdsGenerator';
import { AiPricingEntrypoint } from './AiPricing';
import { AiUsageEntrypoint } from './AiUsage';
import { AttractionsEntrypoint } from './Attractions';
import { ClientRequestsEntrypoint } from './ClientRequests';
import { DashboardView } from './Dashboard';
import { DevicesEntrypoint } from './Devices';
import { Error404 } from './ErrorPages';
import { InMailsEntrypoint } from './InMails';
import { LanguagesEntrypoint } from './Languages';
import { OrganizationsGroupEntrypoint } from './OrganizationGroup';
import { OrganizationsEntrypoint } from './Organizations';
import { ServiceEntrypoint } from './Service';
import { StripeEntrypoint } from './Stripe';
import { TvEntrypoint } from './Tv';
import { UserProfileEntrypoint } from './UserProfile';
import { UsersEntrypoint } from './Users';

const routes = [
  {
    path: '/',
    element: <ProtectedRoute />,
    label: 'Home',
    children: [
      {
        path: '/',
        element: <DashboardView />,
        label: 'Home',
      },
      {
        path: '/organizations/*',
        element: <OrganizationsEntrypoint />,
        label: 'Organizations',
      },
      {
        path: '/stripe/*',
        element: <StripeEntrypoint />,
        label: 'Stripe',
      },
      {
        path: '/organizations-group/*',
        element: <OrganizationsGroupEntrypoint />,
        label: 'Organizations Group',
      },
      {
        path: '/devices/*',
        element: <DevicesEntrypoint />,
        label: 'Devices',
      },
      {
        path: 'users/*',
        element: <UsersEntrypoint />,
        label: 'Users',
      },
      {
        path: 'profile/*',
        element: <UserProfileEntrypoint />,
        label: 'User Profile',
      },
      {
        path: 'attractions/*',
        element: <AttractionsEntrypoint />,
        label: 'Attractions',
      },
      {
        path: 'inmails/*',
        element: <InMailsEntrypoint />,
        label: 'InMails',
      },
      {
        path: 'ads/*',
        element: <AdsEntrypoint />,
        label: 'Reklamy',
      },
      {
        path: 'client-requests/*',
        element: <ClientRequestsEntrypoint />,
        label: 'Client Requests',
      },
      {
        path: 'languages/*',
        element: <LanguagesEntrypoint />,
        label: 'Attractions',
      },
      {
        path: 'tv/*',
        element: <TvEntrypoint />,
        label: 'Tv',
      },
      {
        path: 'ads-generator/*',
        element: <AdsGeneratorEntrypoint />,
        label: 'Ads Generator',
      },
      {
        path: 'ai-usage/*',
        element: <AiUsageEntrypoint />,
        label: 'Użycie AI',
      },
      {
        path: 'ai-pricing/*',
        element: <AiPricingEntrypoint />,
        label: 'Cennik AI',
      },
      {
        path: 'service/*',
        element: <ServiceEntrypoint />,
        label: 'Service',
      },
      {
        path: '*',
        label: 'Error',
        element: <Error404 />,
      },
    ],
  },
  {
    path: '/login',
    element: <SignIn />,
  },
  {
    // Ustawienie hasła z maila (krok 1: e-mail, krok 2: `?oobCode=` z Firebase).
    path: '/set-password',
    element: <SetPassword />,
  },
  {
    path: '/unauthorized',
    element: <AccessDenied />,
  },

];

export const App: FC = () => {
  const renderRoots = useRoutesWithBreadcrumbs(routes);

  ModuleRegistry.registerModules([AllCommunityModule]);
  return (
    <ErrorBoundary>
      <Fragment key="router-render">
        {renderRoots}
      </Fragment>
    </ErrorBoundary>
  );
};
